import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Table, Tooltip, Input, Button, message, Select } from 'antd'
import {
    MdInfoOutline,
} from "react-icons/md";
import Model from '../Layout/Model';
import Pagination from '../Component/Pagination';

const { Option } = Select;

const AllBots = () => {

    const [totalPages, setTotalPages] = useState(0);
    const [searchUsernames, setSearchUsernames] = useState('');
    const [statusFilter, setStatusFilter] = useState("ALL");

    const [filter, setFilter] = useState("ALL");
    const [filter1, setFilter1] = useState("FUTURES");
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50);
    const [data, setData] = useState([]);
    const [selectedSymbol, setselectedSymbol] = useState("ALL")


    const onPageChange = (page) => {
        setPage(page);
    };

    const handlePageSizeChange = (size) => {
        setSize(size);
    };


    const ViewAPIs = (size, page, tradeType, exchangetype, usernames, status) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
        };

        if (tradeType !== "ALL") {
            postData.api_type = [tradeType];
        }

        // if (selectedSymbol !== "ALL") {
        //     postData.api_type = [selectedSymbol];
        // }


        if (usernames) {
            postData.username = usernames.split(',').map((name) => name.trim());
        }

        if (exchangetype !== "ALL") {
            postData.exchange_type = [exchangetype];
        } else {
            postData.exchange_type = ["SPOT", "FUTURE"];
        }

        if (status && status !== 'ALL') {
            postData.status = [status]; 
        }


        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/bot/view_bots',
            data: postData
        }).then(res => {
            if (res?.data?.Success === "No transactions yet!") {
                setData([]);
                // message.info("No transactions yet!");
            } else {
                setData(res?.data?.Success);
                // props.formSubmitted(data)
            }
        }).catch(err => {
            // message.error(err);
        });
    };
    //

    const ViewTotalApis = (size, page, tradeType, exchangetype, usernames, status) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,

        };

        if (tradeType !== "ALL") {
            postData.api_type = [tradeType];
        }


        if (usernames) {
            postData.username = usernames.split(',').map((name) => name.trim());
        }

        if (exchangetype !== "ALL") {
            postData.exchange_type = [exchangetype];
        } else {
            postData.exchange_type = ["SPOT", "FUTURE"];
        }

        if (status && status !== 'ALL') {
            postData.status = [status]; // Add the selected status to the API request
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/bot/total_page_view_bots',
            data: postData
        }).then(res => {
            setTotalPages(res?.data?.Success);
        }).catch(err => {
            console.log(err);
        });
    };

    //
    useEffect(() => {

        ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
        ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);

    }, [page, size, filter, filter1, statusFilter]);

    const getValueForExchangeType = (exchangeType, values) => {
        if (exchangeType === "FUTURES") {
            return values.reduce((acc, val) => acc + (val || 0), 0);
        }
        return values || "--";
    };


    const dataSource = data.map((item) => ({
        Bot_ID: item?.Bot_ID || "--",
        Username: item?.Username || "--",
        APIID: item?.APIID || "--",
        API_Name: item?.API_Name || "--",
        Key: item?.Key || "--",
        Project: item?.Project || "--",
        Secret: item?.Secret || "--",
        Passphrase: item?.Passphrase || "--",
        Exchange_Type: item?.Exchange_Type || "--",
        Exchange: item?.Exchange || "--",
        Type: item?.Type || "--",
        Reason: item?.Reason || "",
        CopyTradeID: item?.CopyTradeID || "--",
        VarBotID: item?.VarBotID || "--",
        BotName: item?.BotName || "--",
        Symbol: item?.Symbol || "--",
        Invest: item?.Invest,
        InvestL: item?.InvestL,
        InvestS: item?.InvestS,
        VolumeMultiplierL: item?.VolumeMultiplierL,
        VolumeMultiplierS: item?.VolumeMultiplierS,
        VolumeMultiplier: item?.VolumeMultiplier,
        Investment_Risk: item?.Investment_Risk,
        LossPercent: item?.LossPercent,
        LossPercentL: item?.LossPercentL,
        LossPercentS: item?.LossPercentS,
        TakeProfitPercent: item?.TakeProfitPercent,
        TakeProfitPercentL: item?.TakeProfitPercentL,
        TakeProfitPercentS: item?.TakeProfitPercentS,
        LossMultiplier: item?.LossMultiplier,
        LossMultiplierL: item?.LossMultiplierL,
        LossMultiplierS: item?.LossMultiplierS,
        OrderCount: item?.OrderCount,
        OrderCountL: item?.OrderCountL,
        OrderCountS: item?.OrderCountS,
        CurrentOrderCount: item?.CurrentOrderCount,
        CurrentOrderCountL: item?.CurrentOrderCountL,
        CurrentOrderCountS: item?.CurrentOrderCountS,
        CurrentVolumeMultiplier: item?.CurrentVolumeMultiplier,
        CurrentVolumeMultiplierL: item?.CurrentVolumeMultiplierL,
        CurrentVolumeMultiplierS: item?.CurrentVolumeMultiplierS,
        CurrentLossMultiplier: item?.CurrentLossMultiplier,
        CurrentLossMultiplierL: item?.CurrentLossMultiplierL,
        CurrentLossMultiplierS: item?.CurrentLossMultiplierS,
        BaseOrderVolumeL: item?.BaseOrderVolumeL?.toFixed(4),
        BaseOrderVolumeS: item?.BaseOrderVolumeS?.toFixed(4),
        BaseOrderVolume: item?.BaseOrderVolume?.toFixed(4),
        Hold: item?.Hold,
        HoldL: item?.HoldL,
        HoldS: item?.HoldS,
        BaseOrderValue: getValueForExchangeType(item?.Exchange_Type, [item?.BaseOrderVolumeL, item?.BaseOrderVolumeS, item?.BaseOrderVolume]),
        BalanceValue: getValueForExchangeType(item?.Exchange_Type, [item?.BalanceL, item?.BalanceS, item?.Balance]),
        Current_Session: item?.Current_Session || "--",
        Current_SessionL: item?.Current_SessionL || "--",
        Current_SessionS: item?.Current_SessionS || "--",
        OrderTypeOpen: item?.OrderTypeOpen || "--",
        OrderTypeClose: item?.OrderTypeClose || "--",
        Drawdown: item?.Drawdown || "--",
        Take_Profit: item?.Take_Profit || "--",
        Status: item?.Status || "--",
        Total_Investment: item?.Total_Investment || "--",
        Initial_Balance: item?.Initial_Balance || "--",
        TotalQuantity: item?.TotalQuantity || "--",
        AvgBuyPrice: item?.AvgBuyPrice || "--",
        Brokerage: item?.Brokerage || "--",
        TotalBrokerage: item?.TotalBrokerage || "--",
        BuyPrice: item?.BuyPrice || "--",
        SellPrice: item?.SellPrice || "--",
        HoldingPeriod: item?.HoldingPeriod || "--",
        Created_At: item?.Created_At,
        // ExpectedBaseOrderVolumeL: item?.ExpectedBaseOrderVolumeL?.toFixed(4),
        // ExpectedBaseOrderVolumeS: item?.ExpectedBaseOrderVolumeS?.toFixed(4),
        // ExpectedBaseOrderVolume: item?.ExpectedBaseOrderVolume?.toFixed(4)
    }));



    // const generateColumns = (filter1) => {
    //     const isFutures = filter1 === "FUTURES";

    //     const conditionalColumns = (title, dataIndexBase, tooltip, keyBase) =>
    //         isFutures
    //             ? [
    //                   { title: <Tooltip title={`${tooltip} Long`}><div>{title} (L)</div></Tooltip>, dataIndex: `${dataIndexBase}L`, key: `${keyBase}L`, className: "whitespace-nowrap " },
    //                   { title: <Tooltip title={`${tooltip} Short`}><div>{title} (S)</div></Tooltip>, dataIndex: `${dataIndexBase}S`, key: `${keyBase}S`, className: "whitespace-nowrap " },
    //               ]
    //             : [
    //                   { title: <Tooltip title={tooltip}><div>{title}</div></Tooltip>, dataIndex: dataIndexBase, key: keyBase, className: "whitespace-nowrap " },
    //               ];

    //     const columns = [
    //         { title: "Datetime", dataIndex: "Created_At", key: "Created_At", className: "whitespace-nowrap " },
    //         ...(isFutures
    //             ? [
    //                   { title: "Current Session Long", dataIndex: "Current_SessionL", key: "Current_SessionL", className: "whitespace-nowrap " },
    //                   { title: "Current Session Short", dataIndex: "Current_SessionS", key: "Current_SessionS", className: "whitespace-nowrap " },
    //               ]
    //             : [
    //                   { title: "Current Session", dataIndex: "Current_Session", key: "Current_Session", className: "whitespace-nowrap " },
    //               ]),
    //         { title: "Username", dataIndex: "Username", key: "username", className: "whitespace-nowrap " },
    //         { title: "Exchange", dataIndex: "Exchange", key: "Exchange", className: "whitespace-nowrap " },
    //         { title: "Type", dataIndex: "Type", key: "Type", className: "whitespace-nowrap " },
    //         { title: "Bot ID", dataIndex: "CopyTradeID", key: "CopyTradeID", className: "whitespace-nowrap " },
    //         { title: "API Name", dataIndex: "API_Name", key: "API_Name", className: "whitespace-nowrap " },
    //         { title: "Bot Name", dataIndex: "BotName", key: "BotName", className: "whitespace-nowrap " },
    //         { title: "Symbol", dataIndex: "Symbol", key: "Symbol", className: "whitespace-nowrap " },
    //         { title: <Tooltip title="Investment Risk"><div>Invest (R)</div></Tooltip>, dataIndex: "Investment_Risk", key: "Investment_Risk", className: "whitespace-nowrap " },
    //         ...conditionalColumns("Invest", "Invest", "Investment", "Invest"),
    //         ...conditionalColumns("VM", "VolumeMultiplier", "Volume Multiplier", "VolumeMultiplier"),
    //         ...conditionalColumns("Loss (%)", "LossPercent", "Loss Percent", "LossPercent"),
    //         ...conditionalColumns("TP (%)", "TakeProfitPercent", "Take Profit Percent", "TakeProfitPercent"),
    //         ...conditionalColumns("LM", "LossMultiplier", "Loss Multiplier", "LossMultiplier"),
    //         ...conditionalColumns("OC", "OrderCount", "Order Count", "OrderCount"),
    //         ...conditionalColumns("COC", "CurrentOrderCount", "Current Order Count", "CurrentOrderCount"),
    //         ...conditionalColumns("CVM", "CurrentVolumeMultiplier", "Current Volume Multiplier", "CurrentVolumeMultiplier"),
    //         ...conditionalColumns("CLM", "CurrentLossMultiplier", "Current Loss Multiplier", "CurrentLossMultiplier"),
    //         { title: "Drawdown", dataIndex: "Drawdown", key: "Drawdown", className: "whitespace-nowrap " },
    //         { title: <Tooltip title="Take Profit"><div>TP</div></Tooltip>, dataIndex: "Take_Profit", key: "Take_Profit", className: "whitespace-nowrap " },
    //         ...conditionalColumns("Hold", "Hold", "Hold", "Hold"),
    //         { title: "Status", dataIndex: "Status", key: "Status", className: "whitespace-nowrap " },
    //     ];

    //     // Define the custom order of columns
    //     const columnOrder = [
    //         "Created_At",           // Order 1: Datetime
    //         "Current_SessionL",     // Order 2: Session Long (for Futures)
    //         "Current_SessionS",     // Order 3: Session Short (for Futures)
    //         "Username",             // Order 4: Username
    //         "Current_Session",      // Order 5: Session ID (for Spot or Futures)
    //         "Investment_Risk",      // Order 6: Invest (R)
    //         "VolumeMultiplier",     // Order 7: Volume Multiplier
    //         "LossPercent",          // Order 8: Loss Percent
    //         "TakeProfitPercent",    // Order 9: TP (%)
    //         "LossMultiplier",       // Order 10: Loss Multiplier
    //         "OrderCount",           // Order 11: Order Count
    //         "CurrentOrderCount",    // Order 12: Current Order Count
    //         "CurrentVolumeMultiplier", // Order 13: Current Volume Multiplier
    //         "CurrentLossMultiplier",  // Order 14: Current Loss Multiplier
    //         "Drawdown",             // Order 15: Drawdown
    //         "Take_Profit",          // Order 16: TP
    //         "Hold",                 // Order 17: Hold
    //         "Status"                // Order 18: Status
    //     ];

    //     // Reorder the columns based on the custom order
    //     const orderedColumns = columnOrder.map((colKey) =>
    //         columns.find((col) => col.key === colKey)
    //     );

    //     return orderedColumns;
    // };

    // const columns = generateColumns(filter1);

    const [statusTPModal, setStatusTPModal] = useState(false)
    const [statusWalletModal, setStatusWalletModal] = useState(false)
    const [selectedData, setSelectedData] = useState()

    const [recordValue, setRecordValue] = useState("")
    const [recordValueUsername, setRecordValueUsername] = useState("")
    const WalletPasswordUpdate = (value, username) => {
        setRecordValue(value)
        setRecordValueUsername(username)
        setStatusWalletModal(true)
    }
    const TransPasswordUpdate = (value, username) => {
        setRecordValue(value)
        setStatusTPModal(true)

        setRecordValueUsername(username)
    }

    const usernameFormat = recordValueUsername;

    const columns = [
        { title: "Datetime", dataIndex: "Created_At", key: "Created_At", className: "whitespace-nowrap " },
        ...(filter1 === "FUTURES" ? [
            { title: "Current Session Long", dataIndex: "Current_SessionL", key: "Current_SessionL", className: "whitespace-nowrap " },
            { title: "Current Session Short", dataIndex: "Current_SessionS", key: "Current_SessionS", className: "whitespace-nowrap " },
        ] : [
            { title: "Current Session", dataIndex: "Current_Session", key: "Current_Session", className: "whitespace-nowrap " },
        ]),
        { title: "Username", dataIndex: "Username", key: "username", className: "whitespace-nowrap " },

        { title: "Exchange", dataIndex: "Exchange", key: "Exchange", className: "whitespace-nowrap " },
        { title: "Bot ID", dataIndex: "CopyTradeID", key: "CopyTradeID", className: "whitespace-nowrap " },
        { title: "API Name", dataIndex: "API_Name", key: "API_Name", className: "whitespace-nowrap " },
        { title: "Bot Name", dataIndex: "BotName", key: "BotName", className: "whitespace-nowrap ", },
        { title: "Symbol", dataIndex: "Symbol", key: "Symbol", className: "whitespace-nowrap " },
        { title: <Tooltip title="Investment Risk"><div>Invest (R)</div></Tooltip>, dataIndex: "Investment_Risk", key: "Investment_Risk", className: "whitespace-nowrap " },
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Invest Long"><div>Invest (L)</div></Tooltip>, dataIndex: "InvestL", key: "InvestL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Invest Long"><div>Invest (S)</div></Tooltip>, dataIndex: "InvestS", key: "InvestS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Invest"><div>Invest</div></Tooltip>, dataIndex: "Invest", key: "Invest", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Volume Multiplier Long"><div>VM(L)</div></Tooltip>, dataIndex: "VolumeMultiplierL", key: "VolumeMultiplierL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Volume Multiplier Short"><div>VM(S)</div></Tooltip>, dataIndex: "VolumeMultiplierS", key: "VolumeMultiplierS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Volume Multiplier"><div>VM</div></Tooltip>, dataIndex: "VolumeMultiplier", key: "VolumeMultiplier", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Loss Percent Long"><div>Loss L(%)</div></Tooltip>, dataIndex: "LossPercentL", key: "LossPercentL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Loss Percent Short"><div>Loss S(%)</div></Tooltip>, dataIndex: "LossPercentS", key: "LossPercentS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Loss Percent"><div>Loss (%)</div></Tooltip>, dataIndex: "LossPercent", key: "LossPercent", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Take Profit Percent Long"><div>TP L(%)</div></Tooltip>, dataIndex: "TakeProfitPercentL", key: "TakeProfitPercentL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Take Profit Percent Short"><div>TP S(%)</div></Tooltip>, dataIndex: "TakeProfitPercentS", key: "TakeProfitPercentS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Take Profit Percent"><div>TP (%)</div></Tooltip>, dataIndex: "TakeProfitPercent", key: "TakeProfitPercent", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Loss Multiplier Long"><div>LM (L)</div></Tooltip>, dataIndex: "LossMultiplierL", key: "LossMultiplierL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Loss Multiplier Short"><div>LM (S)</div></Tooltip>, dataIndex: "LossMultiplierS", key: "LossMultiplierS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Loss Multiplier"><div>LM</div></Tooltip>, dataIndex: "LossMultiplier", key: "LossMultiplier", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Order Count Long"><div>OC (L)</div></Tooltip>, dataIndex: "OrderCountL", key: "OrderCountL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Order Count Short"><div>OC (S)</div></Tooltip>, dataIndex: "OrderCountS", key: "OrderCountS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Order Count"><div>OC</div></Tooltip>, dataIndex: "OrderCount", key: "OrderCount", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Current Order Count Long"><div>COC (L)</div></Tooltip>, dataIndex: "CurrentOrderCountL", key: "CurrentOrderCountL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Current Order Count Short"><div>COC (S)</div></Tooltip>, dataIndex: "CurrentOrderCountS", key: "CurrentOrderCountS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Current Order Count"><div>COC</div></Tooltip>, dataIndex: "CurrentOrderCount", key: "CurrentOrderCount", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Current Volume Multiplier Long"><div>CVM  (L)</div></Tooltip>, dataIndex: "CurrentVolumeMultiplierL", key: "CurrentVolumeMultiplierL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Current Volume Multiplier Short"><div>CVM  (S)</div></Tooltip>, dataIndex: "CurrentVolumeMultiplierS", key: "CurrentVolumeMultiplierS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Current Volume Multiplier"><div>CVM</div></Tooltip>, dataIndex: "CurrentVolumeMultiplier", key: "CurrentVolumeMultiplier", className: "whitespace-nowrap " },
        ]),
        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title="Current Loss Multiplier Long"><div>CLM (L)</div></Tooltip>, dataIndex: "CurrentLossMultiplierL", key: "CurrentLossMultiplierL", className: "whitespace-nowrap " },
            { title: <Tooltip title="Current Loss Multiplier Short"><div>CLM (S)</div></Tooltip>, dataIndex: "CurrentLossMultiplierS", key: "CurrentLossMultiplierS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title="Current Loss Multiplier"><div>CLM</div></Tooltip>, dataIndex: "CurrentLossMultiplier", key: "CurrentLossMultiplier", className: "whitespace-nowrap " },
        ]),

        ...(filter1 === "FUTURES" ? [
            { title: <Tooltip title=" BaseOrder Volume Long"><div>BOV (L)</div></Tooltip>, dataIndex: "BaseOrderVolumeL", key: "BaseOrderVolumeL", className: "whitespace-nowrap " },
            { title: <Tooltip title=" BaseOrder Volume  Short"><div>BOV (S)</div></Tooltip>, dataIndex: "BaseOrderVolumeS", key: "BaseOrderVolumeS", className: "whitespace-nowrap " },
        ] : [
            { title: <Tooltip title=" BaseOrder Volume "><div>BOV</div></Tooltip>, dataIndex: "BaseOrderVolume", key: "BaseOrderVolume", className: "whitespace-nowrap " },
        ]),


        // ...(filter1 === "FUTURES" ? [
        //     { title: <Tooltip title="Actual Base Order Volume Long"><div>ABOV (L)</div></Tooltip>, dataIndex: "BaseOrderVolumeL", key: "BaseOrderVolumeL", className: "whitespace-nowrap " },
        //     { title: <Tooltip title="Actual Base Order Volume Short"><div>ABOV (S)</div></Tooltip>, dataIndex: "BaseOrderVolumeS", key: "BaseOrderVolumeS", className: "whitespace-nowrap " },
        // ] : [
        //     { title: <Tooltip title="Actual Base Order Volume"><div>ABOV</div></Tooltip>, dataIndex: "BaseOrderVolume", key: "BaseOrderVolume", className: "whitespace-nowrap " },
        // ]),







        { title: "Drawdown", dataIndex: "Drawdown", key: "Drawdown", className: "whitespace-nowrap " },
        { title: <Tooltip title="Take Profit"><div>TP</div></Tooltip>, dataIndex: "Take_Profit", key: "Take_Profit", className: "whitespace-nowrap " },
        ...(filter1 === "FUTURES" ? [
            { title: "Hold (L)", dataIndex: "HoldL", key: "HoldL", className: "whitespace-nowrap " },
            { title: "Hold (S)", dataIndex: "HoldS", key: "HoldS", className: "whitespace-nowrap " },
        ] : [
            { title: "Hold", dataIndex: "Hold", key: "Hold", className: "whitespace-nowrap " },
        ]),
        // {
        //     title: "Stop Bot", dataIndex: "stop", key: "stop", className: "whitespace-nowrap ",
        //     render: (text, record) => {
        //         const isDisabled = record.Status === "STOP" || record.Status === "INACTIVE";

        //         return (
        //             <div className="flex items-center gap-3">
        //                 <button
        //                     disabled={isDisabled}
        //                     onClick={() => {
        //                         WalletPasswordUpdate(record.CopyTradeID, record.Username);
        //                     }}
        //                     className={`text-black ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        //                         }`}
        //                 >
        //                     Click
        //                 </button>
        //             </div>
        //         );
        //     }
        // },
        // {
        //     title: "Delete Bot", dataIndex: "delete", key: "delete", className: "whitespace-nowrap ",
        //     render: (text, record) => {
        //         const isDisabled = record.Status === "STOP" || record.Status === "INACTIVE";

        //         return (
        //             <div className="flex items-center gap-3">
        //                 <button
        //                     disabled={isDisabled}
        //                     onClick={() => {
        //                         TransPasswordUpdate(record.CopyTradeID, record.Username);
        //                     }}
        //                     className={`text-black ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        //                         }`}
        //                 >
        //                     Click
        //                 </button>
        //             </div>
        //         );
        //     }
        // },
        {
            title: "Status", dataIndex: "Status", key: "Status", className: "whitespace-nowrap ", render: (text, record) => (
                <>
                    <div className="justify-center flex items-center gap-2">
                        <div>{text}</div>
                        {record.Status === "STOP" ? (
                            <Tooltip title={record.Reason}>
                                {" "}
                                <MdInfoOutline size={15} className="" />
                            </Tooltip>
                        ) : (
                            ""
                        )}
                    </div>
                </>
            ),
        },
    ];

    const allColumns = [...columns];

    const handleSearch = () => {
        setPage(1);
        ViewAPIs(size, 1, filter, filter1, searchUsernames, statusFilter);
    };

    const handleStatusCancelWallet = () => {
        setStatusWalletModal(false);
    };

    const handleStatusCancelTP = () => {
        setStatusTPModal(false);
    };

    const handleTPStatus = (values) => {
        const jwt = localStorage.getItem('jwt')
        const postData = {
            jwt: jwt,
            username: recordValueUsername,
            bot_id: recordValue,
            reason: values?.fundComment
        }

        const response = axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + "/bot/delete_bot",
            data: postData
        }).then(response => {
            const responseData = response?.data
            if (responseData?.Success) {
                message.success(responseData?.Success)
                setStatusTPModal(false)
                ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
                ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
            } else {
                message.error(responseData?.Success)
            }
        }).catch(err => {
            message.error(err?.response?.data?.Error)
        })
    }

    const handleWalletStatus = (values) => {
        const jwt = localStorage.getItem('jwt')
        const postData = {
            jwt: jwt,
            username: recordValueUsername,
            bot_id: recordValue,
            reason: values?.fundComment
        }

        const response = axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + "/bot/stop_bot",
            data: postData
        }).then(response => {
            const responseData = response?.data
            if (responseData?.Success) {
                message.success(responseData?.Success)
                setStatusWalletModal(false)
                ViewTotalApis(size, page, filter, filter1, searchUsernames, statusFilter);
                ViewAPIs(size, page, filter, filter1, searchUsernames, statusFilter);
            } else {
                message.error(responseData?.Success)
            }
        }).catch(err => {
            message.error(err?.response?.data?.Error)
        })
    }

    return (
        <>
            <div>

                <div className="p-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 w-full  mb-4 items-center ">
                        <div className="flex items-center">
                            <Input
                                placeholder="Search username"
                                value={searchUsernames}
                                onChange={(e) => setSearchUsernames(e.target.value.trim().toLowerCase())}
                            // style={{ width: '300px', marginRight: '8px' }}
                            />
                            <Button onClick={handleSearch}>
                                Search
                            </Button>
                        </div>
                        <div>
                            {['ALL', 'LIVE', 'PAPER'].map((type) => (
                                <button
                                    key={type}
                                    className={`mr-2 px-6 py-1 rounded-lg  shadow-md ${filter === type
                                        ? 'bg-colorSecondaryDark text-white border-2 border-white'
                                        : 'bg-white text-colorSecondaryDark'
                                        }`}
                                    onClick={() => setFilter(type)}
                                >
                                    {type}
                                </button>
                            ))}
                        </div>
                        <div>
                            {['FUTURES', 'SPOT'].map((type) => (
                                <button
                                    key={type}
                                    className={`mr-2  px-6 py-1 rounded-lg  shadow-md ${filter1 === type
                                        ? 'bg-colorSecondaryDark text-white border-2 border-white'
                                        : 'bg-white text-colorSecondaryDark'
                                        }`}
                                    onClick={() => setFilter1(type)}
                                >
                                    {type}
                                </button>
                            ))}
                        </div>
                        <div>
                            <Select
                                defaultValue="ALL"
                                style={{ width: 200 }}
                                onChange={(value) => setStatusFilter(value)}
                            >
                                {['ALL', 'ACTIVE', 'INACTIVE', "PAUSED", "STOP"].map((status) => (
                                    <Option key={status} value={status}>
                                        {status}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>




                    <Table dataSource={dataSource} columns={allColumns}
                        pagination={false}
                        // onChange={handleTableChange}

                        scroll={{
                            x: 1000,
                        }}
                    />
                    <Pagination
                        totalPages={totalPages}
                        currentPage={page}
                        pageSize={size}
                        onPageChange={onPageChange}
                        onPageSizeChange={handlePageSizeChange}
                    />



                </div>
            </div>

            <Model
                title={<div className='flex justify-between mr-5 items-center'>
                    <p>Stop Bot</p>
                    <Tooltip title={usernameFormat} className='cursor-pointer'>
                        <div>Bot ID: <span className='font-light'>{recordValue}</span></div>
                    </Tooltip>
                </div>}
                open={statusWalletModal}
                onCancel={handleStatusCancelWallet}
                onFinish={handleWalletStatus}

                label1="Reason"
                name1="fundComment"
                placeholder1="Enter Reason"
                isRequired1={true}
            />
            <Model
                title={<div className='flex justify-between mr-5 items-center'>
                    <p>Delete Bot</p>
                    <Tooltip title={usernameFormat} className='cursor-pointer'>
                        <div>Bot ID: <span className='font-light'>{recordValue}</span></div>
                    </Tooltip>
                </div>}
                open={statusTPModal}
                onCancel={handleStatusCancelTP}
                onFinish={handleTPStatus}

                label1="Reason"
                name1="fundComment"
                placeholder1="Enter Reason"
                isRequired1={true}
            />
        </>
    )
}

export default AllBots
